import RedirectCheckoutCoinsph from "./RedirectCheckoutCoinsph"

export default RedirectCheckoutCoinsph
